import { useState } from "react";
import { ChevronLeft, ChevronRight, Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "./StatusBadge";
import { useLanguage } from "@/i18n/LanguageContext";

export const DetailGallery = ({ images, badge, item, itemType }) => {
  const [idx, setIdx] = useState(0);
  const { isFavorite, toggleFavorite } = useAuth();
  const { t } = useLanguage();
  const fav = item ? isFavorite(itemType, item.slug) : false;
  const list = images && images.length ? images : [item?.image].filter(Boolean);

  if (!list.length) return null;

  return (
    <div className="grid gap-3 lg:grid-cols-[2fr_1fr]" data-testid="detail-gallery">
      <div className="relative h-72 overflow-hidden rounded-3xl sm:h-96">
        <img src={list[idx]} alt={item.name || item.title} className="absolute inset-0 h-full w-full object-cover" />
        {badge && (
          <div className="absolute left-4 top-4">
            <StatusBadge badge={badge} />
          </div>
        )}
        {item && (
          <button
            type="button"
            data-testid="detail-favorite-button"
            onClick={() => toggleFavorite(itemType, item)}
            className="absolute right-4 top-4 flex items-center gap-2 rounded-full bg-white/90 px-4 py-2 text-sm font-semibold text-slate-700 shadow backdrop-blur transition hover:bg-white"
          >
            <Heart className={`h-4 w-4 ${fav ? "fill-red-500 text-red-500" : ""}`} />
            {fav ? t("Enregistré") : t("Ajouter aux favoris")}
          </button>
        )}
        {list.length > 1 && (
          <>
            <button
              type="button"
              data-testid="gallery-prev"
              aria-label={t("Photo précédente")}
              onClick={() => setIdx((idx - 1 + list.length) % list.length)}
              className="absolute left-4 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur transition hover:bg-black/60"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              type="button"
              data-testid="gallery-next"
              aria-label={t("Photo suivante")}
              onClick={() => setIdx((idx + 1) % list.length)}
              className="absolute right-4 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur transition hover:bg-black/60"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
            <span data-testid="gallery-counter" className="absolute bottom-4 right-4 rounded-full bg-black/50 px-3 py-1 text-xs font-semibold text-white">
              {idx + 1} / {list.length}
            </span>
          </>
        )}
      </div>
      <div className="hidden h-96 grid-rows-3 gap-3 lg:grid">
        {list.slice(1, 4).map((src, i) => (
          <button
            key={src + i}
            type="button"
            data-testid={`gallery-thumb-${i + 1}`}
            onClick={() => setIdx(i + 1)}
            className={`overflow-hidden rounded-2xl border-2 transition ${idx === i + 1 ? "border-[#2563EB]" : "border-transparent"}`}
          >
            <img src={src} alt="" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};
